import { environment } from '../../environments/environment';

export module AngularAppConfig {
    export function getNodeAttribute(tagName: string, attributeName: string): string {
        let result: string = null;
        let base = document.getElementsByTagName(tagName);
        if (!base[0]) throw Error("Missing <" + tagName + "> tag in index.html");
        if (!base[0].hasAttribute(attributeName)) throw Error("<" + tagName + "> tag has no '" + attributeName + "' attribute");
        return (base[0]).getAttribute(attributeName);
    }

    export function AppName(): string {
        return environment.appName;

    }
    export function BaseHref(): string {
        return getNodeAttribute("base", "href");
    }
    export function RestServiceUrl(): string {
        return environment.rest_service_url;
    }
    export function SicomOperatoriUrl(): string {
        return environment.sicom_operatori_url;
    }
    export function SicomUrl(): string {
        return environment.sicom_url;
    }

    export function setFavicon(src: string) {
        var link = document.createElement('link');
        var oldLink = document.getElementById('dynamic-favicon');

        link.id = 'dynamic-favicon';
        link.rel = 'shortcut icon';
        link.href = src + '?=' + Math.random();

        if (oldLink) document.head.removeChild(oldLink);
        document.head.appendChild(link);
    }

    export function setStringTag(tagName: string, value: string) {
        let tag: string = this.AppName() + "_" + tagName;
        localStorage.setItem(tag, btoa(value));
    }
    export function setJsonTag(tagName: string, value: any) {
        let tag: string = this.AppName() + "_" + tagName;
        localStorage.setItem(tag, btoa(JSON.stringify(value)));
    }
    export function getStringTag(tagName: string): string {
        let tag: string = this.AppName() + "_" + tagName;
        let value: string = localStorage.getItem(tag);
        if (!value) return null;
        else return atob(value);
    }
    export function getJsonTag(tagName: string): any {
        let tag: string = this.AppName() + "_" + tagName;
        let value: string = localStorage.getItem(tag);
        if (!value) return null;
        else return JSON.parse(atob(localStorage.getItem(tag)));
    }
    export function clearTag(tagName: string) {
        let tag: string = this.AppName() + "_" + tagName;
        localStorage.removeItem(tag);
    }


    export function getUserToken(): string {
        let result: string = null;
        let tag: string = this.AppName() + "_tokens";
        let ssoId: string = environment.sso_id;
        try {
            let tks = JSON.parse(atob(localStorage.getItem(tag)));
            if (tks && tks[ssoId]) result = tks[ssoId];
        }
        catch (err) { }
        return result;
    }
    export function setUserToken(token: string) {
        let result: string = null;
        let tag: string = this.AppName() + "_tokens";
        let ssoId: string = environment.sso_id;
        let tks = {};
        try { tks = JSON.parse(atob(localStorage.getItem(tag))); }
        catch (err) { }
        if (!tks) tks = {};
        tks[ssoId] = token;
        this.setJsonTag("tokens", tks);
    }
    export function clearUserToken() {
        this.clearTag("tokens");
    }

    export function getUserData(): any {
        return this.getJsonTag("userData");
    }
    export function setUserData(userData: any) {
        this.setJsonTag("userData", userData);
    }
    export function clearUserData() {
        this.clearTag("userData");
    }


    export function getFunzioneCorrente(): string {
        return this.getStringTag("funzioneCorrente");
    }
    export function setFunzioneCorrente(externalRequestUrl: string) {
        this.setStringTag("funzioneCorrente", externalRequestUrl);
    }
    export function clearFunzioneCorrente() {
        this.clearTag("funzioneCorrente");
    }


    export function clearSessionStorage() {
        let i = localStorage.length;
        while (i--) {
            if (localStorage.key(i).startsWith(this.AppName())) localStorage.removeItem(localStorage.key(i));
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/functions/app-config.module.ts